/**
 * Created by 唐亦慧 on 2017/8/29.
 */

import {config, request, objectSerial} from 'Utils';


//获取规格列表
export function specList(param) {
	return request(`${config.server}/api/v1/dms/spec/specList`,{
		method: 'post',
		body: param
	});
}


//规格详情--传id
export function specDetail(param) {
	return request(`${config.server}/api/v1/dms/spec/detail`,{
		method: 'get',
		body: param
	});
}
export function productAync() {
	return request(`${config.server}/api/v1/dms/syncCustomer/spec`);
}

//规格新增
/*
* {
 "propertyNum": "test001",       // 规格编码（必填）
 "propertyName": "测试规格001",    // 规格（必填）
 "categoryId": "11251",           // 分类id（必填）
 "propertyCategoryCode": "本体",   // 本体/附件（必填）
 "belongSpecId": "68071",         // 从属规格id（必填）
 "activeFlag": "1",              // 是否有效(1-有效; 0-无效)  （必填）
 "remark": "测试专用",           // 描述 （非必填）
 "specValueList": [{               // 规格值集合
 "id": null,                 // 规格值id（必填）
 "propertyDescName": "desc001",  // 规格值（必填）
 "belongParamId": "624707",      // 从属规格值id（必填）
 "sortNum": "1"                  // 排序（必填）
 }]
 }
* */
export function specAdd(param) {
	return request(`${config.server}/api/v1/dms/spec/save`,{
		method: 'post',
		body: param
	});
}


//删除规格
export function specDelete(param) {
	return request(`${config.server}/api/v1/dms/spec/delete`,{
		method: 'get',
		body: param
	});
}


//规格修改
/*
* DmsProductSpecVo {
 active (integer, optional): 有效性 ,
 description (string, optional): 描述 ,
 id (integer, optional): 主键ID ,
 name (string, optional): 规格名称 ,
 productTypeId (integer, optional): 产品分类id ,
 sortOrder (integer, optional): 排序 ,
 specValueList (Array[DmsProductSpecParam], optional): 规格值列表
 }
 //编辑规格值
 DmsProductSpecParam {
 id (integer, optional): 主键ID ,
 productSpecId (integer, optional): 规格ID ,
 sortOrder (integer, optional): 排序,
 specValue (string, optional): 规格值
 }

 * */

export function specUpdate(param) {
	return request(`${config.server}/api/v1/dms/spec/update`,{
		method: 'post',
		body: param
	});
}
//规格失效--传id+active
export function specInvalid(param) {
	return request(`${config.server}/api/v1/dms/spec/invalid?${objectSerial(param)}`,{
		method: 'post',
		body: param
	});
}
/*产品从属规格下拉框
{
	"categoryId":"11251",    // 分类id （必填）
	"propertyCategoryCode":"本体"     // 本体/附件（必填）
}*/
export function belongSpeclist(param) {
	return request(`${config.server}/api/v1/dms/spec/belongSpeclist`,{
		method: 'post',
		body: param
	});
}

/*产品从属规格值下拉框
 {
 "categoryId":"11251",   // 分类id（必填）
 "propertyCategoryCode":"本体",  // 本体/附件（必填）
 "propertyNum":"KDDL"   // 规格编码（必填）
 }*/
export function belongSpecValuelist(param) {
	return request(`${config.server}/api/v1/dms/spec/belongSpecValuelist`,{
		method: 'post',
		body: param
	});
}
// 逻辑删除产品规格值

/*逻辑删除产品规格值
 {
 "id":"11251",   // 规格值id
 }*/
export function deleteSpecParam(param) {
	return request(`${config.server}/api/v1/dms/spec/deleteSpecParam`,{
		method: 'get',
		body: param
	});
}



// WEBPACK FOOTER //
// ./src/service/productSpec/index.js